import {
  imgPath,
  INDEX_URL_GJXX,
  ossPath,
  REGISTER_URL,
  TOLOGIN_URL,
  VUE_APP_OLD_USER_CENTER_URL,
} from "@/utils/constants/constants";

// 注册即享受以下服务
export const registerEnjoyService = [
  {
    img: `${imgPath}/oneold/layout/service-icon01.png`,
    text: "重点项目查询",
  },
  {
    img: `${imgPath}/oneold/layout/service-icon02.png`,
    text: "发布招标信息",
  },
  {
    img: `${imgPath}/oneold/layout/service-icon03.png`,
    text: "最新招标查询",
  },
  {
    img: `${imgPath}/oneold/layout/service-icon04.png`,
    text: "招标机构查询",
  },
  {
    img: `${imgPath}/oneold/layout/service-icon05.png`,
    text: "项目动态追踪",
  },
  {
    img: `${imgPath}/oneold/layout/service-icon06.png`,
    text: "行业研究报告",
  },
];

export const hotIndustry = [
  {
    text: "房屋建筑",
    id: "45535",
  },
  {
    text: "建筑工程",
    id: "370",
  },
  {
    text: "防水工程",
    id: "283310",
  },
  {
    text: "环卫设施",
    id: "190259",
  },
  {
    text: "园林",
    id: "373",
  },
  {
    text: "绿化",
    id: "372",
  },
  {
    text: "景观",
    id: "538",
  },
  {
    text: "市政工程",
    id: "432886",
  },
  {
    text: "医疗卫生",
    id: "33",
  },
  {
    text: "交通运输",
    id: "24",
  },
  {
    text: "仓储物料",
    id: "267309",
  },
  {
    text: "道路标志",
    id: "134033",
  },
  {
    text: "仪器仪表",
    id: "22",
  },
  {
    text: "水利工程",
    id: "461031",
  },
  {
    text: "电力设备",
    id: "261568",
  },
  {
    text: "化工设备",
    id: "1657",
  },
  {
    text: "弱电工程",
    id: "39999",
  },
  {
    text: "安防工程",
    id: "102252",
  },
  {
    text: "办公用品",
    id: "562",
  },
  {
    text: "办公家具",
    id: "549",
  },
  {
    text: "体育器械",
    id: "351513",
  },
  {
    text: "教育产品",
    id: "377470",
  },
  {
    text: "通讯",
    id: "275",
  },
  {
    text: "通讯工程",
    id: "405",
  },
  {
    text: "通讯设备",
    id: "146469",
  },
  {
    text: "工程机械",
    id: "23",
  },
  {
    text: "机械加工",
    id: "32",
  },
  {
    text: "农业机械",
    id: "1153",
  },
  {
    text: "畜牧设备",
    id: "369812",
  },
  {
    text: "农用化工",
    id: "292603",
  },
];

export const governmentOrgans = [
  {
    text: "公共资源交易中心",
    id: "0100020",
    type: "aa",
  },
  {
    text: "招标办",
    id: "5",
    type: "hot",
  },
  {
    text: "市政工程信息网",
    id: "19",
    type: "hot",
  },
  {
    text: "工程交易中心",
    id: "12",
    type: "hot",
  },
  {
    text: "招标投标监管网",
    id: "0200270",
    type: "dd",
  },
  {
    text: "人力资源和社会保障网",
    id: "44",
    type: "hot",
  },
  {
    text: "税务局",
    id: "0203010",
    type: "dd",
  },
  {
    text: "教育局",
    id: "0203020",
    type: "dd",
  },
  {
    text: "财政局",
    id: "0203030",
    type: "dd",
  },
  {
    text: "政务网",
    id: "283",
    type: "hot",
  },
];

export const biddingRecommendation = [
  {
    text: "采购网",
    id: "0100030",
    type: "aa",
  },
  {
    text: "采购信息网",
    id: "6",
    type: "hot",
  },
  {
    text: "建设工程信息网",
    id: "0200120",
    type: "dd",
  },
  {
    text: "造价信息网",
    id: "17",
    type: "hot",
  },
  {
    text: "建设工程招投标网",
    id: "0200280",
    type: "dd",
  },
  {
    text: "考试院",
    id: "0203050",
    type: "aa",
  },
  {
    text: "工程造价信息网",
    id: "0100190",
    type: "aa",
  },
  {
    text: "装修招标",
    id: "0300180",
    type: "aa",
  },
  {
    text: "建材网",
    id: "1",
    type: "hot",
  },
  {
    text: "建设招标网",
    id: "26",
    type: "hot",
  },
];

// 筛选器2 筛选类型
export const typeFilter2 = [
  {
    text: "招标采购",
    id: "4",
  },
  {
    text: "招标公告",
    id: "0",
  },
  {
    text: "招标预告",
    id: "1",
  },
  {
    text: "招标变更",
    id: "2",
  },
  {
    text: "中标结果",
    id: "3",
  },
];

// 筛选器2 地区
export const areasFilter2 = [
  {
    text: "安徽",
    areaId: "1",
  },
  {
    text: "北京",
    areaId: "2",
  },
  {
    text: "福建",
    areaId: "3",
  },
  {
    text: "甘肃",
    areaId: "4",
  },
  {
    text: "广东",
    areaId: "5",
  },
  {
    text: "广西",
    areaId: "6",
  },
  {
    text: "贵州",
    areaId: "7",
  },
  {
    text: "海南",
    areaId: "8",
  },
  {
    text: "河北",
    areaId: "9",
  },
  {
    text: "河南",
    areaId: "10",
  },
  {
    text: "黑龙江",
    areaId: "11",
  },
  {
    text: "湖北",
    areaId: "12",
  },
  {
    text: "湖南",
    areaId: "13",
  },
  {
    text: "吉林",
    areaId: "14",
  },
  {
    text: "江苏",
    areaId: "15",
  },
  {
    text: "江西",
    areaId: "16",
  },
  {
    text: "辽宁",
    areaId: "17",
  },
  {
    text: "内蒙古",
    areaId: "18",
  },
  {
    text: "宁夏",
    areaId: "19",
  },
  {
    text: "青海",
    areaId: "20",
  },
  {
    text: "山东",
    areaId: "21",
  },
  {
    text: "山西",
    areaId: "22",
  },
  {
    text: "陕西",
    areaId: "23",
  },
  {
    text: "上海",
    areaId: "24",
  },
  {
    text: "四川",
    areaId: "25",
  },
  {
    text: "天津",
    areaId: "26",
  },
  {
    text: "西藏",
    areaId: "27",
  },
  {
    text: "新疆",
    areaId: "28",
  },
  {
    text: "云南",
    areaId: "29",
  },
  {
    text: "浙江",
    areaId: "30",
  },
  {
    text: "重庆",
    areaId: "31",
  },
];
export const topSubstation = [
  {
    url: `${INDEX_URL_GJXX}/zb/area_5`,
    text: "广东",
    title: "广东招标网",
  },
  {
    url: `${INDEX_URL_GJXX}/zb/area_2`,
    text: "北京",
    title: "北京招标网",
  },
  {
    url: `${INDEX_URL_GJXX}/zb/area_15`,
    text: "江苏",
    title: "江苏招标网",
  },
  {
    url: `${INDEX_URL_GJXX}/zb/area_30`,
    text: "浙江",
    title: "浙江招标网",
  },
  {
    url: `${INDEX_URL_GJXX}/zb/area_21`,
    text: "山东",
    title: "山东招标网",
  },
  {
    url: `${INDEX_URL_GJXX}/zb/area_12`,
    text: "湖北",
    title: "湖北招标网",
  },
  {
    url: `${INDEX_URL_GJXX}/zb/area_1`,
    text: "安徽",
    title: "安徽招标网",
  },
  {
    url: `${INDEX_URL_GJXX}/zb/area_9`,
    text: "河北",
    title: "河北招标网",
  },
];
// 登录导航
export const loginNav = [
  {
    id: 0 + "login",
    text: "登录",
    url: TOLOGIN_URL,
  },
  {
    id: 1 + "login",
    text: "注册",
    url: REGISTER_URL,
  },
];
// 其他导航
export const otherNav = [
  {
    url: VUE_APP_OLD_USER_CENTER_URL,
    text: "我的会员中心",
    id: 0,
  },
  {
    state: "handle",
    text: "退出",
    id: 1,
  },
  {
    url: `${VUE_APP_OLD_USER_CENTER_URL}/tradeCenter_Service.html`,
    text: "资费标准",
    id: 2,
  },
  {
    url: `${INDEX_URL_GJXX}/about/fkfs.shtml`,
    text: "付款方式",
    id: 3,
  },
];
export const footerNav = [
  {
    id: 0,
    url: INDEX_URL_GJXX,
    text: "千里马首页",
  },
  {
    id: 1,
    url: `${INDEX_URL_GJXX}/about/about.shtml`,
    text: "关于我们",
  },
  {
    id: 2,
    url: `${INDEX_URL_GJXX}/about/contact.shtml`,
    text: "联系我们",
  },
  {
    id: 3,
    url: ossPath + "/0qlmgw/qlmBuinessCase/index.html",
    text: "成功案例",
  },
  {
    id: 4,
    url: `${INDEX_URL_GJXX}/common/huiyuan.jsp`,
    text: "会员服务",
  },
  {
    id: 5,
    url: `${INDEX_URL_GJXX}/about/fkfs.shtml`,
    text: "付款方式",
  },
  {
    id: 6,
    url: `${INDEX_URL_GJXX}/about/ggbj.shtml`,
    text: "广告服务",
  },
  {
    id: 7,
    url: `${INDEX_URL_GJXX}/common/law_list.jsp`,
    text: "招标法规",
  },
  {
    id: 8,
    url: `${INDEX_URL_GJXX}/about/copyright.shtml`,
    text: "网站声明",
  },
  {
    id: 9,
    url: `${INDEX_URL_GJXX}/about/yqlj.shtml`,
    text: "友情链接",
  },
  {
    id: 10,
    url: `${INDEX_URL_GJXX}/common/sitemap.html`,
    text: "网站地图",
  },
  {
    id: 11,
    type: "handle",
    text: "收藏本站",
  },
];
export const keepOnRecordUrl = [
  {
    id: 0,
    url: "https://beian.miit.gov.cn/",
    text: "京ICP证160587号",
  },
  {
    id: 1,
    url: "https://beian.miit.gov.cn/",
    text: "京ICP备16007318号-2",
  },
];
// 头部导航数据
export const topNavs = [
  {
    text: "首页",
    url: "/",
  },
  {
    text: "招标公告",
    url: `${INDEX_URL_GJXX}/zbgg`,
  },
  {
    text: "招标预告",
    url: `${INDEX_URL_GJXX}/zbyg`,
  },
  {
    text: "中标结果",
    url: `${INDEX_URL_GJXX}/zbjg`,
  },
  {
    text: "精选项目",
    url: `${INDEX_URL_GJXX}/jxxm`,
  },
  {
    text: "业主委托项目",
    url: `${INDEX_URL_GJXX}/vipxm`,
  },
  {
    text: "招标机构库",
    url: `${INDEX_URL_GJXX}/common/agents/`,
  },
  {
    text: "公共资源交易中心",
    url: `${INDEX_URL_GJXX}/hot80938`,
  },
  {
    text: "人力资源和社会保障网",
    url: `${INDEX_URL_GJXX}/hot440938`,
  },
  {
    text: "政府采购",
    url: `${INDEX_URL_GJXX}/01000100938aa/`,
  },
];
export const classifications = [
  {
    url: `${INDEX_URL_GJXX}/seomap/a_1/`,
    text: "A",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/b_1/`,
    text: "B",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/c_1/`,
    text: "C",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/d_1/`,
    text: "D",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/e_1/`,
    text: "E",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/f_1/`,
    text: "F",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/g_1/`,
    text: "G",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/h_1/`,
    text: "H",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/i_1/`,
    text: "I",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/j_1/`,
    text: "J",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/k_1/`,
    text: "K",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/l_1/`,
    text: "L",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/m_1/`,
    text: "M",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/n_1/`,
    text: "N",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/o_1/`,
    text: "O",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/p_1/`,
    text: "P",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/q_1/`,
    text: "Q",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/r_1/`,
    text: "R",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/s_1/`,
    text: "S",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/t_1/`,
    text: "T",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/u_1/`,
    text: "U",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/v_1/`,
    text: "V",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/w_1/`,
    text: "W",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/x_1/`,
    text: "X",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/y_1/`,
    text: "Y",
  },
  {
    url: `${INDEX_URL_GJXX}/seomap/z_1/`,
    text: "Z",
  },
];
